import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import {
    capitalize,
    combineClasses,
} from 'wanderu-css';

import TableContext from '../Table/TableContext';

import styles from './TableCell.scss';

function TableCell(props) {
    const {
        classes: classesProps = {},
        className,
        component: ComponentProp,
        componentProps,
        variant = 'body',
        align = 'left',
        padding,
        size = 'medium',
        ...otherProps
    } = props;

    const isHeader = variant === 'head';
    const Component = ComponentProp ?? (isHeader
        ? 'th'
        : 'td');
    const { orientation } = React.useContext(TableContext);
    const horizontalHeader = isHeader && orientation === 'horizontal';

    let scope;
    if (isHeader) {
        scope = horizontalHeader
            ? 'row'
            : 'col';
    }

    const classes = combineClasses(styles, classesProps);

    return (
        <Component
            className={clsx(
                classes.root,
                classes[variant],
                {
                    [classes[`text${capitalize(align)}`]]: align !== 'inherit',
                    [classes[`size${capitalize(size)}`]]: size !== 'medium',
                },
                className,
            )}
            scope={scope}
            {...componentProps}
            {...otherProps}
        />
    );
}

TableCell.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
    variant: PropTypes.oneOf(['body', 'head']),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default TableCell;
